var ko = require('knockout');

ko.components.register('submit-button', {
  viewModel: require('./submit-button'),
  template: require('./submit-button.template')
});

$('[data-submit-button]').each(function() {
  ko.applyBindings({}, this);
});
